import RootStore from '@App/stores/root-store'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { AxiosResponse } from 'axios'
import { Collection } from '@Entities/collection'
import { WorkMergeRequestSummary } from '@Entities/rightsholder/work-merge'

export type WorkMergeRequestGetFunction = (
    rightsholderId: number
) => Promise<AxiosResponse<Collection<WorkMergeRequestSummary>>>

export default class WorkMergeRequestListStore {
    private rootStore: RootStore

    private readonly workMergeRequestGetFunction: WorkMergeRequestGetFunction

    constructor(rootStore: RootStore, workMergeRequestGetFunction: WorkMergeRequestGetFunction) {
        makeObservable<WorkMergeRequestListStore, '_requests' | '_isLoading'>(this, {
            _requests: observable,
            _isLoading: observable,
            reset: action,
        })
        this.rootStore = rootStore
        this.workMergeRequestGetFunction = workMergeRequestGetFunction
    }

    private _requests: WorkMergeRequestSummary[] = []

    private _isLoading = false

    get requests(): WorkMergeRequestSummary[] {
        return this._requests
    }

    get isLoading(): boolean {
        return this._isLoading
    }

    async loadRequests(): Promise<void> {
        runInAction(() => {
            this._isLoading = true
        })

        try {
            const result = await this.workMergeRequestGetFunction(
                this.rootStore.rightsholderStore.currentRightsholderId
            )
            runInAction(() => {
                this._requests = result.data?.data ?? []
            })
        } catch (e) {
            this.rootStore.popupStore.setAlertFromError(e)
        } finally {
            runInAction(() => {
                this._isLoading = false
            })
        }
    }

    reset(): void {
        this._requests = []
        this._isLoading = false
    }
}
